import { IDemandPreview } from '../../demand/types/DemandPreview';
import { PurchaseRequisitionStatusEnum } from './PurchaseRequistionStatusEnum';
import { PurchaseRequisitionStatus } from './PurchaseRequisitionStatus';
import { PurchaseRequisitionDeliveryStatus, PurchaseRequisitionOrderStatus } from '@lib/util';
import dayjs from 'dayjs';
import {
    IPurchaseRequisitionOrderResult,
    IPurchaseRequisitionResultDocument,
    IPurchaseRequisitionRfqResult,
    PurchaseRequisitionOrderResult,
    PurchaseRequisitionRfqResult,
} from './IPurchaseRequisitionResultDocument';

export interface IPurchaseRequisitionPreview {
    id: string;
    displayNumber: string;
    demand: IDemandPreview;
    created: string;
    status: PurchaseRequisitionStatusEnum;
    orderStatus: PurchaseRequisitionOrderStatus;
    deliveryStatus: PurchaseRequisitionDeliveryStatus;
    closed: boolean;
    orders: IPurchaseRequisitionOrderResult[];
    rfqs: IPurchaseRequisitionRfqResult[];
}

export class PurchaseRequisitionPreview {
    public readonly status: PurchaseRequisitionStatus;
    public readonly created: string;
    public readonly orders: IPurchaseRequisitionResultDocument[];
    public readonly rfqs: IPurchaseRequisitionResultDocument[];

    public static fromDto(dto: IPurchaseRequisitionPreview): PurchaseRequisitionPreview {
        return new PurchaseRequisitionPreview(
            dto.id,
            dto.displayNumber,
            dto.demand,
            dto.created,
            dto.status,
            dto.orderStatus,
            dto.deliveryStatus,
            dto.closed,
            dto.rfqs,
            dto.orders
        );
    }

    constructor(
        public readonly id: string,
        public readonly displayNumber: string,
        public readonly demand: IDemandPreview,
        _created: string,
        _status: PurchaseRequisitionStatusEnum,
        public readonly orderStatus: PurchaseRequisitionOrderStatus,
        public readonly deliveryStatus: PurchaseRequisitionDeliveryStatus,
        public readonly closed: boolean,
        rfqs: IPurchaseRequisitionRfqResult[],
        orders: IPurchaseRequisitionOrderResult[]
    ) {
        this.status = new PurchaseRequisitionStatus(_status);
        this.created = dayjs(_created).format('DD.MM.YYYY HH:mm');
        demand.suppliers = [...demand.suppliers].sort((left, right) =>
            left.contact.companyName.localeCompare(right.contact.companyName),
        );
        this.rfqs = rfqs.map((dto) => PurchaseRequisitionRfqResult.fromDto(dto));
        this.orders = orders.map((dto) => PurchaseRequisitionOrderResult.fromDto(dto));
    }
}
